const EMPTY_STROKE = '#f3f4f6';
const EMPTY_TEXT = '#9ca3af';

interface RingGaugeProps {
    pct: number | null;
    color: string;
    size: number;
    strokeWidth: number;
    /** Size and weight of the percentage in the middle. */
    valueClassName: string;
}

// The bare progress ring with its percentage; StatRing and compact strips add their own labels.
export function RingGauge({ pct, color, size, strokeWidth, valueClassName }: RingGaugeProps) {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const hasValue = pct != null;
    const offset = hasValue ? circumference - (pct / 100) * circumference : circumference;

    return (
        <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
            <svg width={size} height={size} className="-rotate-90">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={EMPTY_STROKE}
                    strokeWidth={strokeWidth}
                />
                {hasValue && (
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke={color}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        className="transition-all duration-700"
                    />
                )}
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
                <span className={valueClassName} style={{ color: hasValue ? color : EMPTY_TEXT }}>
                    {hasValue ? `${pct}%` : '--'}
                </span>
            </div>
        </div>
    );
}
